export default {
  //加拿大28 玩法
  bets28: ['三星大小单双', '三星特码', '三星波色龙虎和', '三星豹子顺子对子'],
};
